import { Modal } from 'ht-styleguide';
import styles from '../locationPage.module.scss';

type VideoModalProps = {
  videoUrl: string;
  showModal: boolean;
  toggleVideo: BaseAnyFunction;
};
const VideoModal = ({ showModal, videoUrl, toggleVideo }: VideoModalProps) => (
  <Modal
    isVisible={showModal}
    hide={toggleVideo}
    onRequestClose={toggleVideo}
    modalClassName={styles.modal}
    modalCloseButtonClasses={styles.modalClose}
  >
    <div>
      <iframe title="hellotech media" width="100%" height="300" src={videoUrl} frameBorder="0" allowFullScreen />
    </div>
  </Modal>
);

export default VideoModal;
